import React, { Component } from 'react';
import Project from './Project';
import './../stylesheets/App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Project />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js